var _use, _defs, _symbol;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwsFargate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 88 107",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 1.5,
    y: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "7%",
    stopColor: "#eb9742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71%",
    stopColor: "#f9d566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23%",
    stopColor: "#ec9a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "98%",
    stopColor: "#f9d566"
  })))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "C",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.892 36.53q-6.793-3.988-5.983-3.021 11.769 7.009 17.201 13.175-1.489-4.394-11.182-10.068Q88.743 44.74 83.84 53.622q-13.335 14.76-50.264 12.363Q7.557 62.878 1.071 52.778-3.881 42.679 14.069 34.134q-27.45 13.984 5.338 25.636 30.185 6.367 53.938-2.567 21.07-7.311-4.73-22.785",
    fill: "#f9d15e",
    stroke: "#f9d15e",
    strokeLinejoin: "miter",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.738 75.355l-9.369-4.685L14 75.355V87.4l9.369 4.685 9.369-4.685z",
    fill: "#fef7e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.381 80.037l-9.369-4.685v12.046l9.369 4.685 9.369-4.685V75.352z",
    fill: "#fceabf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.369 80.037v12.048l9.369-4.685V75.352zm45.619-4.682l-9.369-4.685-9.369 4.685V87.4l9.369 4.685 9.369-4.685z",
    fill: "#fef7e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.631 80.037l-9.369-4.685v12.046l9.369 4.685L69 87.398V75.352z",
    fill: "#fceabf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.619 80.037v12.048l9.369-4.685V75.352zm-8.631 7.733l-9.369-4.685-9.369 4.685v12.046l9.369 4.685 9.369-4.685z",
    fill: "#fef7e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.631 92.452l-9.369-4.685v12.046l9.369 4.685L51 99.813V87.767z",
    fill: "#fceabf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.619 92.452V104.5l9.369-4.685V87.767z",
    fill: "#fef7e5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.497 15.579q1.028 0 1.028 32.159Q22.748 55 40.223 55q23.642 0 27.753-10.374-1.028 1.037-1.028-32.159Q53.585 6.242 41.25.018 28.916 7.28 13.497 15.579z",
    fill: "url(#A)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.626 50.699c.147.172.31.329.489.468.305.262.625.507.957.733l.224.122a9.83 9.83 0 0 0 1.018.55l.631.265h.204.224l.509.224 3.217 1.12 1.853.55.998.265c5.089 1.247 10.314 1.856 15.554 1.812h0a56.39 56.39 0 0 0 23.208-4.438 9.04 9.04 0 0 0 5.293-8.143V15.011c-.005-1.236-.717-2.359-1.832-2.891L29.886.312c-.855-.416-1.853-.416-2.708 0L1.832 12.12C.717 12.651.005 13.775 0 15.011v29.316a9.04 9.04 0 0 0 2.219 5.945 4.09 4.09 0 0 0 .407.428zm10.383.285l-1.71-.509c-1.099-.346-2.036-.712-2.871-.997l-.733-.305h0l-.692-.326a6.97 6.97 0 0 1-.672-.346h0l-.509-.387-.265-.285a.61.61 0 0 0-.163-.163l-.163-.183c-.778-.899-1.204-2.048-1.201-3.237V17.454l22.394 10.484v24.919c-4.221-.075-8.421-.621-12.52-1.629zm37.052-2.158c-6.18 2.64-12.824 4.024-19.544 4.072V28.325l22.394-10.179v26.059c.061 1.972-1.06 3.791-2.85 4.621zM28.502 4.16l22.516 10.505-22.15 9.935-.163-.102L6.82 14.318z",
    fill: "url(#B)",
    fillRule: "nonzero",
    stroke: "none",
    transform: "translate(13.497)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsFargate);
export default __webpack_public_path__ + "static/media/aws-fargate.87255878d3f05ab1c162f582c40057c1.svg";
export { ForwardRef as ReactComponent };